"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runOtlp = void 0;
const sdk_trace_web_1 = require("@opentelemetry/sdk-trace-web");
const resources_1 = require("@opentelemetry/resources");
const semantic_conventions_1 = require("@opentelemetry/semantic-conventions");
const sdk_trace_base_1 = require("@opentelemetry/sdk-trace-base");
const exporter_trace_otlp_http_1 = require("@opentelemetry/exporter-trace-otlp-http");
const core_1 = require("@opentelemetry/core");
const context_zone_1 = require("@opentelemetry/context-zone");
const instrumentation_1 = require("@opentelemetry/instrumentation");
const instrumentation_xml_http_request_1 = require("@opentelemetry/instrumentation-xml-http-request");
const instrumentation_fetch_1 = require("@opentelemetry/instrumentation-fetch");
const commonAttributesSpanProcessor_1 = require("./processors/commonAttributesSpanProcessor");
const rtlWebVitalsInstrumentation_1 = require("./instrumentations/rtlWebVitalsInstrumentation");
const rtlJsLogsInstrumentation_1 = require("./instrumentations/rtlJsLogsInstrumentation");
const rtlDocumentLoadInstrumentation_1 = require("./instrumentations/rtlDocumentLoadInstrumentation");
let isInitialized = false;
/**
 * Runs the initialization of OpenTelemetry
 * @param {TelemetryConfig} config
 * @returns {WebTracerProvider | null}
 */
function runOtlp(config) {
    if (config.browserRoute) {
        (0, commonAttributesSpanProcessor_1.setBrowserRoute)(config.browserRoute);
    }
    if (config.sessionId) {
        (0, commonAttributesSpanProcessor_1.setSessionId)(config.sessionId);
    }
    if (typeof window === 'undefined' || isInitialized) {
        return null;
    }
    isInitialized = true;
    if (config.debug) {
        console.debug('App Build: ' + config.version);
    }
    const provider = new sdk_trace_web_1.WebTracerProvider({
        resource: new resources_1.Resource({
            [semantic_conventions_1.SemanticResourceAttributes.SERVICE_NAME]: config.serviceName,
            [semantic_conventions_1.SemanticResourceAttributes.SERVICE_VERSION]: config.version,
        }),
    });
    provider.addSpanProcessor(new commonAttributesSpanProcessor_1.CommonAttributesSpanProcessor(new sdk_trace_base_1.BatchSpanProcessor(new exporter_trace_otlp_http_1.OTLPTraceExporter({
        headers: {},
        url: config.otlp.url,
    }))));
    const propagator = new core_1.CompositePropagator({
        propagators: [new core_1.W3CTraceContextPropagator(), new core_1.W3CBaggagePropagator()],
    });
    provider.register({
        contextManager: new context_zone_1.ZoneContextManager(),
        propagator: propagator,
    });
    const propagateTraceHeaderCorsUrls = [
        /https:\/\/(test-api|acc-api|api).rtl.nl.*/,
        /https:\/\/(test-api|acc-api|api).videoland.com.*/,
    ];
    const ignoreUrls = [/https:\/\/(?:[\w\-\_]+\.)akamaized.net.*/, /https:\/\/rtl.hb.omtrdc.net.*/];
    (0, instrumentation_1.registerInstrumentations)({
        instrumentations: [
            new rtlWebVitalsInstrumentation_1.RtlWebVitalsInstrumentation(config.version),
            new rtlJsLogsInstrumentation_1.RtlJsLogsInstrumentation(config.version),
            new rtlDocumentLoadInstrumentation_1.RtlDocumentLoadInstrumentation(config.version),
            new instrumentation_xml_http_request_1.XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls,
                ignoreUrls: ignoreUrls,
            }),
            new instrumentation_fetch_1.FetchInstrumentation({
                propagateTraceHeaderCorsUrls,
                ignoreUrls: ignoreUrls,
            }),
        ],
    });
    return provider;
}
exports.runOtlp = runOtlp;
